import {SET_TRANSLATIONS} from '../constants/drafts-constants';

export default function translations(state = {}, action) {
    switch(action.type) {
        case SET_TRANSLATIONS:
            return {...state, ...action.translations};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_app/drafts/reducers/translation_reducer.js